
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchMaterialDetail } from '@/services/material';

export interface IMaterialFile {
  name: string;
  size: number;
  url: string;
  status: 'success' | 'fail'
}

export interface IMateriallDetail {
  id?: string;
  materialId?: string;
  name?: string;
  outlines: IMaterialFile[];
  biographies: IMaterialFile[];
  summaries: IMaterialFile[];
  audioSounds: IMaterialFile[];
  audioTexts: IMaterialFile[];
  images: IMaterialFile[];
  videos: IMaterialFile[]
}

export interface MaterialState {
  materialInfo: IMateriallDetail,
}

export const materialInitialState: MaterialState = {
  materialInfo: {
    name: '',
    outlines: [],
    biographies: [],
    summaries: [],
    audioSounds: [],
    audioTexts: [],
    images: [],
    videos: [],
  },
};

export const getMaterialDetail = createAsyncThunk('material/detail', fetchMaterialDetail);
export const material = createSlice({
  name: 'basic',
  initialState: materialInitialState,
  reducers: {
    initMaterial() {
      return {
        ...materialInitialState,
      };
    },
    updateMaterialInfo(state, action) {
      state.materialInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMaterialDetail.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      materialInfo: payload,
    }));
  },
});

export const { updateMaterialInfo, initMaterial } = material.actions;

export default material.reducer;
